/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface DatePeriod
 */
export interface DatePeriod  {
    /**
     * 
     * @type {Date}
     * @memberof DatePeriod
     */
    start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DatePeriod
     */
    end?: Date;
}

/**
 * Check if a given object implements the DatePeriod interface.
 */
export function instanceOfDatePeriod(value: object): value is DatePeriod {
    return true;
}

export function DatePeriodFromJSON(json: any): DatePeriod {
    return DatePeriodFromJSONTyped(json, false);
}

export function DatePeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatePeriod {
    if (json == null) {
        return json;
    }
    return {
        
                'start': json['start'] == null ? undefined : (new Date(json['start'])),
                'end': json['end'] == null ? undefined : (new Date(json['end'])),
    };
}

export function DatePeriodToJSON(json: any): DatePeriod {
    return DatePeriodToJSONTyped(json, false);
}

export function DatePeriodToJSONTyped(value?: DatePeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start': value['start']?.toISOString().substring(0,10),
        'end': value['end']?.toISOString().substring(0,10),
    };
}


